/**
 * ЭТАП 2 — ЛОАДЕР FLOCKTORY ПОДКЛЮЧАЕТСЯ ПОСЛЕ ГИДРАЦИИ, А НЕ ИЗ `<head>`.
 *
 * ПОЧЕМУ ТАК, ХОТЯ В ЛЕГАСИ-ШАБЛОНЕ ОН СТОЯЛ В ШАПКЕ. В SPA к моменту
 * запуска стороннего скрипта страница была пустой: React ещё не построил
 * DOM, цепляться Flocktory было не к чему, и он всегда отрабатывал ПОСЛЕ
 * приложения. Под SSR всё наоборот — готовая разметка приходит первым же
 * ответом, и `async`-скрипт из `<head>` успевает вставить в неё свои узлы
 * ДО того, как React начнёт гидрацию.
 *
 * Чем это кончается, поймано 30.08.2026 на странице рецепта с телефона:
 * Flocktory вставил `<span class="fl-embedded-wrapper">` ровно туда, где
 * React ждал нижнюю панель «в корзину / оценить», гидрация упала
 * («server rendered HTML didn't match»), и React перерисовал поддерево
 * целиком. Никаким `defer` это не лечится: отложенные классические скрипты
 * всё равно выполняются раньше модуля приложения.
 *
 * Поэтому лоадер вешаем сами — первым же эффектом после гидрации
 * (`RootEffects`). Цена: рекламно-персонализационный виджет стартует на
 * доли секунды позже. Взамен — целая страница не перерисовывается.
 * `preconnect` на их домен остаётся в `<head>`, так что соединение к этому
 * моменту уже поднято.
 */
const FLOCKTORY_LOADER_SRC =
  'https://api.flocktory.com/v2/loader.js?site_id=4398';

export const loadFlocktory = (): void => {
  if (typeof document === 'undefined') {
    return;
  }
  // Идемпотентность: RootEffects монтируется один раз, но StrictMode в dev
  // прогоняет эффекты дважды — второй тег дал бы второй экземпляр виджета
  if (document.querySelector(`script[src="${FLOCKTORY_LOADER_SRC}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.src = FLOCKTORY_LOADER_SRC;
  script.async = true;
  document.head.appendChild(script);
};
